import { getRangeLabel } from '../../../../utils/getRangeLabel';
export const getValueLabel = (value) => {
    if (value.label) {
        return value.label;
    }
    return getRangeLabel(value.dates);
};
